export default "__VITE_ASSET__CbdseJXJ__"